/**
 * Mini Prixia: las seis misiones del recorrido, en el orden en que se hacen.
 * Cada una abre su pantalla y arranca el tour de esa pantalla (motor de
 * `features/guided-tour`). X3 (decisión 22): queda hecha cuando la persona HACE lo
 * que pide el último paso; lo anota el servidor (`misiones-demo.service.ts`) o, si
 * sólo pasa en la pantalla, la pantalla (`acciones-de-misiones.ts`).
 */
export type IdDeMision =
  | 'monitoreo'
  | 'catalogo'
  | 'vincular'
  | 'analitica'
  | 'estrategia'
  | 'decidir';

export interface Mision {
  id: IdDeMision;
  titulo: string;
  detalle: string;
  ruta: string;
  /** El `id` del `TourConfig` de esa pantalla. */
  tour: string;
  /** Lo que falta para cumplirla, en una línea: se ve en curso y con el recorrido cerrado. */
  falta: string;
  /** Orden sugerido: sin ésta cumplida, al abrirla se avisa «Primero …» (se puede seguir igual). */
  requiere?: IdDeMision;
  /**
   * Ronda Y: al cumplirse, su recorrido no se cierra y pasa a este paso (el
   * `trasCumplir` del recorrido; el contrato lo comprueba).
   */
  pasoTrasCumplir?: number;
}

export const MISIONES: Mision[] = [
  {
    id: 'monitoreo',
    titulo: 'Mira tus precios',
    detalle: 'Tus productos de ejemplo frente a la tienda que elegiste.',
    // La pestaña de productos: la de cambios (la que abre por omisión) no tiene la lista.
    ruta: '/compite/monitoreo?tab=productos',
    tour: 'demo-monitoreo',
    falta: 'Te falta abrir un producto de la lista.',
  },
  {
    id: 'catalogo',
    titulo: 'Carga tu catálogo',
    detalle: 'Hasta 100 productos tuyos, con la plantilla o a mano.',
    ruta: '/compite/productos',
    tour: 'demo-productos',
    falta: 'Te falta subir tu planilla o crear un producto.',
  },
  {
    id: 'vincular',
    titulo: 'Vincula con inferencia',
    detalle: 'Prixia encuentra tus productos en la tienda que elegiste.',
    // Ronda Y: directo a Revisar vínculos, donde se confirma («Es este» / «Es variante»).
    ruta: '/compite/productos?tab=vincular&modo=revisar',
    tour: 'demo-vincular',
    falta: 'Te falta confirmar un vínculo que te propone Prixia.',
    requiere: 'catalogo',
  },
  {
    id: 'analitica',
    titulo: 'Mira tu analítica',
    detalle: 'Dónde estás parado frente al mercado.',
    ruta: '/compite/analitica',
    tour: 'demo-analitica',
    falta: 'Te falta tocar un tramo del gráfico de posición.',
  },
  {
    id: 'estrategia',
    titulo: 'Crea una estrategia',
    detalle: 'Reglas y estrategias sobre los de ejemplo.',
    ruta: '/compite/estrategia',
    tour: 'demo-estrategia',
    falta: 'Te falta crear una regla o una estrategia.',
    // Decisión de Sebastián (Ronda Y): al crearla, el recorrido indica «Revisar ahora».
    pasoTrasCumplir: 3,
  },
  {
    id: 'decidir',
    titulo: 'Decide precios',
    detalle: 'Aprueba o descarta lo que propone Prixia.',
    ruta: '/compite/decisiones',
    tour: 'demo-decisiones',
    falta: 'Te falta aprobar o descartar un precio.',
    requiere: 'estrategia',
  },
];
